import { paginationFragment } from './fragments/pagination';
import { salesLeadFragment } from './fragments/salesLeads';

const fragment = `
  id
  offerPrice
  counterOfferPrice
  status
  statusChangeDates
  isUsingRealtor
  realtorName
  requiredDepositAmount
  signStatus
  signStatusChangeDates
  signNote
  signedDocumentUrl
  createdAt
  manuallyCompletedAt
  home {
    id
    beds
    baths
    sizeSqft
    totalPrice
    homeUrl
    createdAt
    singleFamilyHome {
      isQuickPossession
      isLot
      lot
      model {
        id
        name
        imageUrl
        defaultImageUrl
        productType {
          id
          name
        }
      }
      community {
        id
        name
      }
      elevation {
        id
        imageUrl
      }
    }
    multiFamilyHome {
      project {
        id
        name
      }
      unit {
        id
        name
        defaultImageUrl
        buildingModel {
          id
          name
          bedrooms
          bathrooms
          size
        }
      }
    }
  }
  user {
    name
    phones
    contact {
      id
      name
      street
      state
      zip
      phone
    }
    preApproval {
      id
      verificationMethod
      documentUrl
    }
  }
  salesLead {
    ${salesLeadFragment}
  }
`;

export const listOffersQuery = `
  query ListOffers(
    $filter: OfferFilterInput
    $page: Int
    $pageSize: Int
  ) {
    result: listOffers(filter: $filter, page: $page, pageSize: $pageSize) {
      items {
        ${fragment}
      }
      pagination {
        ${paginationFragment}
      }
    }
  }
`;

export const getOfferQuery = `
  query GetOffer($id: Int!) {
    item: getOffer(id: $id) {
      ${fragment}
    }
  }
`;

export const createOfferQuery = `
  mutation CreateOffer(
    $input: CreateOfferInput!
  ) {
    item: createOffer(input: $input) {
      ${fragment}
    }
  }
`;

export const updateOfferQuery = `
  mutation UpdateOffer(
    $input: UpdateOfferInput!
  ) {
    item: updateOffer(input: $input) {
      ${fragment}
    }
  }
`;

export const deleteOfferQuery = `
  mutation DeleteOffer($id: Int!) {
    item: deleteOffer(id: $id) {
      ${fragment}
    }
  }
`;

export const markOfferAsCompleteMutation = `
  mutation MarkOfferAsComplete($input: MarkOfferCompleteInput!) {
    manuallyCompletedAt: markOfferAsComplete(input: $input)
  }
`;

export const createOfferDocumentToSignTemplateQuery = `
  mutation CreateOfferDocumentToSignTemplate($id: Int!, $documentId: String!) {
    templateId: createOfferDocumentToSignTemplate(id: $id, documentId: $documentId)
  }
`;

export const getDealsPriceMaxQuery = `
  query GetDealsPriceMax($companyId: Int!) {
    maxPrice: getDealsPriceMax(companyId: $companyId)
  }
`;
